















































import { Vue, Component } from 'vue-property-decorator';
import { Route } from 'vue-router';

@Component
export default class Post extends Vue {
  isLogin = true;

  show = false;

  mounted() {
    this.isLogin = this.$route.name !== 'register';
  }

  beforeRouteUpdate(to: { name: string }, from: Route, next: () => void) {
    this.isLogin = to.name !== 'register';
    next();
  }
}
